<template>
  <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" variant="text">
    {{ $t(`lottery.addon.${name}`) }}
  </LcLotteryLogo>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

type LotteryAddOnLogoProps = {
  licensedTerritory: string
  lotteryId: LotteryId
  name: string
}

defineProps<LotteryAddOnLogoProps>()
</script>
